import React from 'react';

import { StepHorizontal, StepVertical } from './components';
import { StepsWrapper } from './Stepper.styles';

export interface StepperProps {
  steps: string[];
  currentStep: number;
  variant: 'horizontal' | 'vertical';
  stepText?: string;
  verticalSingleLine?: boolean;
}
const Stepper = ({
  steps,
  currentStep,
  variant = 'vertical',
  stepText,
  verticalSingleLine = false,
}: StepperProps) => {
  return (
    <StepsWrapper variant={variant}>
      {variant === 'horizontal' &&
        steps.map((step, i) => (
          <StepHorizontal
            isActive={currentStep === i}
            isCompleted={currentStep > i}
            key={step}
            stepCount={i + 1}
            title={step}
          />
        ))}
      {variant === 'vertical' &&
        steps.map((step, i) => (
          <StepVertical
            stepText={stepText}
            stepCount={i + 1}
            title={step}
            key={step}
            isActive={currentStep === i}
            isCompleted={currentStep > i}
            verticalSingleLine={verticalSingleLine}
          />
        ))}
    </StepsWrapper>
  );
};

export default Stepper;
